import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import lodash from "lodash";
import AsyncSelect from "react-select/lib/Async";
import classnames from "classnames";
import Switch from "react-switch";

class DigiFormLocationsToggleAll extends React.Component {
	state = {
    loading: false,
    locationsToSelect: [],
    selectedLocations: this.props.value,
		allLocations: this.props.allLocations || false
  };

  componentWillMount() {
    axios.get("/locations.json?active=true")
      .then((resp) => {
        this.setState({ locationsToSelect: resp.data });
      })
    ;
  }

  componentWillReceiveProps(newProps) {
    if(this.props != newProps) {
      this.setState({
        fieldErrors: newProps.fieldErrors
      });
    }
  }

  render() {
    const {
      loading,
      locationsToSelect,
      selectedLocations,
			allLocations
    } = this.state;

    const locationsToSelectFormatted = locationsToSelect.map(location => ({
      value: location.id,
      label: location.name
    }));

    const {
      label,
      required,
      fieldErrors,
			onChange
    } = this.props;

		return (
			<div>
				<hr />
				<label id="all-locations-custom-forms">All Locations</label>
				<br />
				<Switch
					checked={allLocations}
					onChange={this.toggleAllLocations}
					onColor="#DADCE1"
					onHandleColor="#3A4590"
					handleDiameter={25}
					uncheckedIcon={false}
					checkedIcon={false}
					boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
					activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
					height={20}
					width={48}
					className="react-switch"
					name="all_locations_toggle"
          aria-labelledby="all-locations-custom-forms"
				/>
				<br />
				{!allLocations &&
					<div
						className={classnames("form-group", {
							"has-error": fieldErrors && fieldErrors.length > 0
						})}
					>
						{label ? (
							<label
								className="control-label word-wrap"
								htmlFor={`select${name}`}
                id="digi-form-toggle-locations-label"
							>
								{label}
								{required ? " *" : ""}
							</label>
						) : null}
						<AsyncSelect
							isMulti={true}
							cacheOptions
              aria-labelledby="digi-form-toggle-locations-label"
							className="custom-react-select"
							value={this.state.selectedLocations.filter(location => location._destroy !== true)}
							defaultOptions={locationsToSelectFormatted}
							loadOptions={this.loadOptions}
							onChange={this.handlerChangeLocations}
              styles={{
                placeholder: (provided) => ({
                  ...provided,
                  color: "#666666", 
                })
              }}
						/>

						{fieldErrors ? (
							<span className="help-block">{fieldErrors.join(", ")}</span>
						) : null}
					</div>
				}
			</div>
		);
	}

	toggleAllLocations = () => {
		const newAllLocations = !this.state.allLocations;
		this.setState({ allLocations: newAllLocations });
		this.props.onChange(newAllLocations, "all_locations");
	};

  handlerChangeLocations = newLocations => {
    const selectedLocations = this.state.selectedLocations;
    // Add a new location
    newLocations.forEach(location => {
      const idx = lodash.findIndex(selectedLocations, { value: location.value });
      if (idx === -1) {
        selectedLocations.push({
          value: location.value,
          location_id: location.value,
          label: location.label
        });
      } else {
				if(selectedLocations[idx]["_destroy"] == true) {
					selectedLocations[idx]["_destroy"] = false;
				}
			}
    });

    // Remove a new location or remove a selected location
    selectedLocations.forEach((location, index) => {
      const idx = lodash.findIndex(newLocations, { value: location.value });
      if (idx === -1) {
        if (location.id) {
          location._destroy = true;
        } else {
          selectedLocations.splice(idx, 1);
        }
      }
    });

    this.setState({ selectedLocations: selectedLocations, fieldErrors: {} });
    this.props.onChange(selectedLocations, this.props.associationName);
  };

  buildDataResult = (locations, selectedLocationsIds) => {
    return locations.filter(location => !selectedLocationsIds.includes(location.id)).map(location => {
      return {
        value: location.id.toString(),
        label: location.name
      };
    });
  };

  loadOptions = inputValue => {
    const urlSearch = "/locations.json?search={q}";

    const url = urlSearch.replace("{q}", encodeURIComponent(inputValue));
    return axios.get(url).then(resp => this.buildDataResult(
      resp.data, this.state.selectedLocations.map(l => l.id)
    ));
  };
}

export default DigiFormLocationsToggleAll;
